import { render, staticRenderFns } from "./return-goods.vue?vue&type=template&id=4f6d2705"
import script from "./return-goods.vue?vue&type=script&lang=js"
export * from "./return-goods.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./return-goods.vue?vue&type=style&index=1&id=4f6d2705&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports